import Navbar from "@/components/site/Navbar";
import { Seo } from "@/components/site/Seo";
import Footer from "@/components/site/Footer";
import Contact from "@/components/site/Contact";
import FirstVisit from "@/components/site/FirstVisit";
import WhereNext from "@/components/site/WhereNext";

const nextItems = [
  { sub: "Explore our lessons", label: "Our Swimming Lessons", to: "/classes" },
  { sub: "How lessons are structured", label: "What to Expect", to: "/how-it-works" },
  { sub: "Check class availability", label: "Weekly Timetable", to: "/timetable" },
  { sub: "Ready when you are", label: "Book Now", to: "/book" },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#334155] font-body" data-testid="contact-page">
      <Seo
        title="Contact Us — Book a Swim Lesson | Happy Tiddlers"
        description="Get in touch with Happy Tiddlers Swim School in Barton-le-Clay. Enquire about baby, children's and adult swimming lessons, or call 01582 883820."
        path="/contact"
      />
      <Navbar />
      <main className="pt-8 md:pt-12">
        <Contact />
        <FirstVisit />
        <WhereNext items={nextItems} />
      </main>
      <Footer />
    </div>
  );
}
